import styled from 'styled-components';
import { vars } from '@snsw-gel/theming';
import global from 'app/theme/styles/global';

const mobileBreakpoint = `${global.breakpoints.small.value}px`;

export const PoliceFooterDivider = styled.hr`
  width: 100%;
  border: none;
  border-top: 1px solid ${vars.colors.neutral.grey300};
`;

export const PoliceFooterLinks = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 2rem;

  @media (max-width: ${mobileBreakpoint}) {
    flex-direction: column;
    gap: 0.75rem;
  }
`;

export const PoliceFooterLinkItem = styled.li`
  margin: 0;
  padding: 0;

  a {
    color: ${vars.colors.text.reversed};
    text-decoration: underline;

    &:hover,
    &:focus {
      color: #d9e1f2;
    }
  }
`;
